import { DateRange } from '../../redux/dateRangeSlice';
import { get } from '..';

interface GetExternalEnvironmentDataParams {
  metric: string,
  field: string,
  range: DateRange,
  interval?: string,
}

const GetExternalEnvironmentData = ({
  metric, field, range, interval,
}: GetExternalEnvironmentDataParams) => {
  let endpoint: string = `button/external-environment-data?field=${field}&metric=${metric}`;
  endpoint += `&from=${new Date(range.start).toISOString()}&to=${new Date(range.end).toISOString()}`;
  if (interval) endpoint += `&interval=${interval}`;
  return get(endpoint);
};

export default GetExternalEnvironmentData;
